module.exports = __webpack_public_path__ + "img/World Gym.20fa0a21.svg";